<ion-content class="theme-{{userService.theme}}">
    <ion-header class="white"><app-header></app-header></ion-header>

    <div class="content-wrap">
        <div class="text">
            <strong class="my-color-blue">{{'__COACHING_NAME__' | translate}} </strong>
            <span *ngIf="dataForm !== null" [@enter]>{{dataForm.delegate.fullname}}</span>
        </div>
        <div class="text">
            <strong class="my-color-blue">{{'__COACHING_DATE__' | translate}} </strong>
            <span *ngIf="dataForm !== null" [@enter]>{{dataForm.dateOutput.output.long}}</span>
        </div>

        <div class="name-input" *ngIf="dataForm && dataForm.type === 'SELF'">
            <div class="name-input-subtitle my-color-blue">{{'__COACHING_ENTER_COACHEE_NAME__' | translate}}</div>
            <ion-input name="coachee-name" [(ngModel)]="dataForm.coachee_name.value"></ion-input>
        </div>

        <ng-container *ngIf="dataForm !== null">

            <div class="table-text" [@enter] [innerHTML]="'__COACHING_DESCRIPTION__' | translate"></div>

            <div class="table">
                <ng-container *ngFor="let group of dataForm.groups.value; let i = index;">
                    <div class="blue-box primary-bg-color" [ngStyle]="{color: group.color, background: group.background}"
                         [@leave]>{{group.title}}</div>

                    <ng-container *ngFor="let question of group.questions.value; let j = index;">
                        <div class="text"
                             [@leave]>{{question.question}}</div>
                        <app-rating [(value)]="question.value.value" [delay] = "i * 5 * 15 + j * 15"></app-rating>
                    </ng-container>

                </ng-container>
            </div>

            <div class="comments-wrap" *ngIf="dataForm && dataForm.type === 'OTHERS'">
                <div class="head">
                    <div class="title">{{'__COACHING_MANAGER_COMMENTS__' | translate}}</div>
                </div>
                <textarea [(ngModel)]="dataForm.description.value" (change)="onChange($event)"></textarea>
            </div>

            <ng-container *ngIf="dataForm && dataForm.type === 'SELF'">
                <div class="comments-wrap">
                    <div class="head">
                        <div class="title">{{'__COACHING_SELF_COMMENT_ONE__' | translate}}</div>
                    </div>
                    <textarea [(ngModel)]="dataForm.comment_self_1.value" (change)="onChange($event)"></textarea>
                </div>
                <div class="comments-wrap">
                    <div class="head">
                        <div class="title">{{'__COACHING_SELF_COMMENT_TWO__' | translate}}</div>
                    </div>
                    <textarea [(ngModel)]="dataForm.comment_self_2.value" (change)="onChange($event)"></textarea>
                </div>
                <div class="comments-wrap">
                    <div class="head">
                        <div class="title">{{'__COACHING_SELF_COMMENT_THREE__' | translate}}</div>
                    </div>
                    <textarea [(ngModel)]="dataForm.comment_self_3.value" (change)="onChange($event)"></textarea>
                </div>
            </ng-container>

            <div class="date-line">
                <app-inline-svg [cssClass]="'touch-eff-radius'" [file]="'assets/img/journey/save-btn.svg'" (click)="onSave()"></app-inline-svg>
                <div class="date">
                    <div class="meeting-date-label">{{'__REVIEW_REPORT_MEETING_DATE__' | translate}}:</div>
                    <div class="meeting-date-datepicker">
                        <app-readonly [readonly]="dataForm.date.options.read_only">
                            <app-datepicker
                                (ngModelChange)="onChange($event)"
                                name="meeting_at"
                                [locale]="userService.userInfo.language.code"
                                [disabled]="dataForm.date.options.read_only"
                                [(date)]="dataForm.date.value"
                            ></app-datepicker>
                        </app-readonly>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ion-content>
